import { Routes } from "@angular/router";
import { AppLayoutComponent } from "../app-layout/app-layout.component";
import { HealthMapLayoutComponent } from "../health-map-layout/health-map-layout.component";
import { LoginLayoutComponent } from "../login-layout/login-layout.component";
import { HomeComponent } from "../main/home/home/home.component";
import { PetDetailsComponent } from "../main/pet-details/pet-details.component";
import { PlansComponent } from "../main/plans/plans.component";
import { RegistrationComponent } from "../main/registration/registration.component";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { LoginComponent } from "./login/login.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";

export const authRoutes: Routes = [
  {
    path: "",
    component: AppLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "",
        pathMatch: "full",
      },
      {
        path: "",
        component: HomeComponent,
      },
      {
        path: "plans/:id",
        component: PlansComponent,
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Wellness Plans",
            },
          ],
        },
      },
      {
        path: "plans/:id/:slug",
        component: PlansComponent,
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Wellness Plans",
            },
          ],
        },
      },
      {
        path: "plans/:pageType/:id/:cartId",
        component: PlansComponent,
        data: {
          type: "edit",
        },
      },
      {
        path: "pet_details/:id",
        component: PetDetailsComponent,
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Dashboard",
              url: "/dashboard",
            },
            {
              title: "My Pets",
              url: "/pets",
            },
            { title: "View Details" },
          ],
        },
      },
      {
        path: "grooming",
        loadChildren: () =>
          import("../main/grooming/grooming-routes").then((m) => m.routes),
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Grooming Services",
            },
          ],
        },
      },
      {
        path: "product",
        loadChildren: () =>
          import("../main/product/product-routes").then((m) => m.routes),
      },
      {
        path: "outposts",
        loadChildren: () =>
          import("../main/out-post-list/out-post-list-routes").then(
            (m) => m.routes
          ),
      },
      {
        path: "",
        loadChildren: () =>
          import("../main/boarding/boarding-routes").then((m) => m.routes),
      },
    ],
  },

  {
    path: "",
    component: HealthMapLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "/",
        pathMatch: "full",
      },
      {
        path: "health-map",
        loadChildren: () =>
          import("../main/health-map/health-map-routes").then((m) => m.routes),
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "Health Map",
            },
          ],
        },
      },
      {
        path: "health-map/:petId",
        loadChildren: () =>
          import("../main/health-map/health-map-routes").then((m) => m.routes),
        data: {
          urls: [
            {
              title: "Home",
              url: "/",
            },
            {
              title: "My Pets",
              url: "/pets",
            },
            {
              title: "Generate Health Map",
            },
          ],
        },
      },
      {
        path: "health-map/:petId/:custom",
        loadChildren: () =>
          import("../main/health-map/health-map-routes").then((m) => m.routes),
      },
      {
        path: "health-map/:petId/:custom/:editInput",
        loadChildren: () =>
          import("../main/health-map/health-map-routes").then((m) => m.routes),
      },
    ],
  },

  {
    path: "",
    component: LoginLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "/",
        pathMatch: "full",
      },
      {
        path: "login",
        component: LoginComponent,
        data: { pageName: "Login" },
      },
      {
        path: "registration",
        component: RegistrationComponent,
        data: { pageName: "Registration" },
      },
      {
        path: "forgot_password",
        component: ForgotPasswordComponent,
        data: { pageName: "Forgot Password" },
      },
      {
        path: "reset_password/:id",
        component: ResetPasswordComponent,
        data: { pageName: "Reset Password" },
      },
    ],
  },
];
